import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { CoachMarksModal } from '../models/coachmark.model';

const API_BASE_URL = environment.apiUrl;

@Injectable({
    providedIn: 'root'
})
export class CoachMarkHttpService {

    constructor(private readonly http: HttpClient) { }

    //public methods
    getCoachMark(): Observable<CoachMarksModal> {
        let url = API_BASE_URL + 'api/User/CoachMarks';
        url = url.replace(/[?&]$/, "");

        return this.http.get<any>(url);
    }

    updateCoachMark(request: CoachMarksModal): Observable<CoachMarksModal> {
        let url = API_BASE_URL + 'api/User/CoachMarks';
        url = url.replace(/[?&]$/, "");

        return this.http.put<CoachMarksModal>(url, request);
    }

    resetCoachMark(): Observable<CoachMarksModal> {
        let url = API_BASE_URL + 'api/User/ResetCoachMarks';
        url = url.replace(/[?&]$/, "");

        return this.http.put<any>(url, {});
    }
}
